function pad(n) {
  return String(n).padStart(2, "0");
}

export default function registerReschedulePopover(Alpine) {
  Alpine.data("reschedulePopover", ({ open = false } = {}) => ({
    open,
    popoverStyle: "",
    init() {
      this.$nextTick(() => {
        if (this.open) this.position();
      });
    },
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.$nextTick(() => {
          this.position();
          const popover = this.$refs.popover;
          if (popover) {
            const focusable = popover.querySelector(
              'input:not([type=hidden]), button:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
            );
            if (focusable) focusable.focus();
          }
        });
      } else {
        this.$refs.trigger?.focus();
      }
    },
    close() {
      const wasOpen = this.open;
      this.open = false;
      if (wasOpen) this.$nextTick(() => this.$refs.trigger?.focus());
    },
    position() {
      if (!this.open) return;
      const trigger = this.$refs.trigger;
      const popover = this.$refs.popover;
      if (!trigger || !popover) return;
      const rect = trigger.getBoundingClientRect();
      const popWidth = popover.offsetWidth || 320;
      const popHeight = popover.offsetHeight || 240;
      const margin = 8;
      let left = rect.left;
      if (left + popWidth + margin > window.innerWidth) {
        left = Math.max(margin, window.innerWidth - popWidth - margin);
      }
      let top = rect.bottom + 4;
      if (top + popHeight + margin > window.innerHeight) {
        top = Math.max(margin, rect.top - popHeight - 4);
      }
      this.popoverStyle = `left: ${left}px; top: ${top}px;`;
    },
    isInsideUI(target) {
      if (!target) return false;
      if (this.$refs.popover && this.$refs.popover.contains(target)) return true;
      if (this.$refs.trigger && this.$refs.trigger.contains(target)) return true;
      return Boolean(target.closest && target.closest(".datepicker, .flatpickr-calendar, [role='dialog']"));
    },
    handleOutside(event) {
      if (!this.isInsideUI(event.target)) this.close();
    },
    applyPreset(offsetDays) {
      const d = new Date();
      d.setDate(d.getDate() + offsetDays);
      d.setHours(9, 0, 0, 0);
      const dd = pad(d.getDate());
      const mm = pad(d.getMonth() + 1);
      const yyyy = d.getFullYear();
      const hh = pad(d.getHours());
      const mi = pad(d.getMinutes());
      const root = this.$refs.popover;
      if (!root) return;
      const hidden = root.querySelector('input[type=hidden][name$="[occurred_at]"]');
      if (hidden) hidden.value = `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
      const dateInput = root.querySelector('[x-ref="datepickerInput"]');
      if (dateInput) {
        dateInput.value = `${dd}/${mm}/${yyyy}`;
        dateInput.dispatchEvent(new Event("changeDate", { bubbles: true }));
      }
      const timeRoot = root.querySelector('[x-data^="timepickerDropdown"]');
      if (timeRoot && window.Alpine) {
        const data = window.Alpine.$data(timeRoot);
        if (data) {
          data.selected = `${hh}:${mi}`;
          data.open = false;
        }
      }
    }
  }));
}
